/**
 * Copy for the three bundle-level error states that carry real link
 * semantics (rotation, archiving, an unknown slug) — shared verbatim between
 * the hub (BundleHub) and the in-script switcher wrapper (BundleScriptView)
 * so a rotated/archived/unknown bundle reads identically no matter which URL
 * a client landed on.
 */
export type BundleErrorKind = 'not_found' | 'replaced' | 'unavailable';

export interface BundleErrorCopy {
  eyebrow: string;
  heading: string;
  body: string;
}

export function bundleErrorCopy(kind: BundleErrorKind): BundleErrorCopy {
  switch (kind) {
    case 'replaced':
      return {
        eyebrow: '// LINK REPLACED',
        heading: 'This link has been replaced',
        body: 'A new review link has been issued for these scripts. Henry can send it straight over.',
      };
    case 'not_found':
      return {
        eyebrow: '// 404',
        heading: 'Bundle not found',
        body: 'The link may be incorrect, or these scripts may have been moved. Henry can check and send you a fresh link.',
      };
    case 'unavailable':
      return {
        eyebrow: '// ARCHIVED',
        heading: 'This link is no longer available',
        body: 'This project has wrapped, so the link’s been archived. Give me a shout if you need anything from it.',
      };
  }
}
